import React from "react";
import CommonTable from "components/CommonTable";
import { getErrorMessage } from "helpers/strings";
import styled from "styled-components";
import { toast } from "react-toastify";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useCompanySelector, useCompanyDispatch } from 'company-app/redux/company.store';
import { buildFiltersQuery, goToPage } from 'company-app/redux/filter.slice';
import { Spinner } from "react-bootstrap";
import { TbEditCircle } from "react-icons/tb";
import { TiDocumentDelete } from "react-icons/ti";
import { getProductBuys, deleteProductBuy } from "network/apis/BuyApi";
import useModal from "hooks/useModal";
import DeleteInputPrompt from "components/DeleteInputPrompt";
import { getPersianFormattedDate } from "helpers/dates";
import HoverText from 'components/HoverText';

const cols = [
  "حذف",
  "ویرایش",
  "توضیحات",
  "تاریخ ثبت",
  "تاریخ خرید",
  "فروشنده",
  "مبلغ (ریال)",
  "واحد",
  "مقدار",
  "نوع نهاده",
  "ردیف",
];

const Holder = styled.div`
  width: 100%;

  div.loading {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #3876e5;
    min-height: 30rem;
  }
`;

const BuyTab = ({ buysData, isLoading, refetch, onEditTap }) => {
  const queryClient = useQueryClient();

  const filterState = useCompanySelector((store) => store.filter);
  const dispatch = useCompanyDispatch();

  const {
    isOpen: isDeleteModalOpen,
    handleOpenModal: handleOpenDeleteModal,
    handleCloseModal: handleCloseDeleteModel,
    data: deleteModalData,
  } = useModal();

  const deleteBuyMutation = useMutation(deleteProductBuy, {
    onSuccess: (res) => {
      if (res && res.status === 204) {
        toast(`با موفقیت حذف گردید`, {
          type: "success",
          position: "bottom-right",
        });

        refetch();
        queryClient.invalidateQueries(['company-get-product-statistics']);
      }
    },
    onError: (err) => {
      toast(getErrorMessage(err), {
        type: "error",
        position: "bottom-right",
      });
    },
  });

  return (
    <Holder>
      {isLoading ? (
        <div className="loading">
          <Spinner animation="border" role="status" />
        </div>
      ) : (
        <CommonTable
          cols={cols}
          pageCount={parseInt(buysData?.data?.num_pages ?? 1)}
          pageOffset={filterState.pageOffset - 1}
          fetchPageAt={(pageOffset) => {
            dispatch(goToPage(pageOffset));
            dispatch(buildFiltersQuery());
          }}
        >
          {buysData?.data?.items?.map((buy, index) => (
            <tr key={`${buy?.pur_id}-${buy?.created_at}`}>
              <td>
                <TiDocumentDelete
                  onClick={() => {
                    handleOpenDeleteModal(buy);
                  }}
                />
              </td>
              <td>
                <TbEditCircle onClick={() => {
                  onEditTap?.(buy);
                }} />
              </td>
              <td>
                <HoverText>{buy?.description ?? '-'}</HoverText>
              </td>
              <td>{getPersianFormattedDate(buy?.created_at)}</td>
              <td>{getPersianFormattedDate(buy?.date)}</td>
              <td>{buy?.purchased_from ?? '-'}</td>
              <td>{`${buy?.cost ?? 0}`.persianCurrency()}</td>
              <td>{buy?.unit?.name}</td>
              <td>{`${buy?.amount ?? 0}`.persianCurrency()}</td>
              <td>{buy?.input?.name}</td>
              <td>{index + 1}</td>
            </tr>
          ))}
        </CommonTable>
      )}
      {isDeleteModalOpen && (
        <DeleteInputPrompt
          isOpen={isDeleteModalOpen}
          onClose={handleCloseDeleteModel}
          onActionTap={(warehouseSelected) => {
            handleCloseDeleteModel();
            deleteBuyMutation.mutate({ id: deleteModalData?.pur_id, warehouseSelected: true });
          }}
        />
      )}
    </Holder>
  );
};

export default BuyTab;
